import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Field from '../../../../../../../../components/Form/Field'
import { useTranslation } from 'react-i18next'

import { selectedSelfAccountSelector } from '../../../../../../../../modules/selectors/app'

import { getRepresentativeTitle } from '../../../../../../../../forms/ManageClientAccountRepresentatives/RepresentativeSection/helpers'

import {
  clearGetSelfAccountRepresentatives,
  getSelfAccountRepresentatives
} from '../../../../../../../../modules/actions/selfAccounts'
import { getSelfAccountRepresentativesSelector } from '../../../../../../../../modules/selectors/selfAccounts'

import { CUSTOMER_REPRESENTATIVE } from '../../../../../../../../forms/ReusableFormFields/RecipientsFields/fields'

const CustomerRepresentativeField = ({ formik }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { values } = formik

  const selfAccount = useSelector(selectedSelfAccountSelector)
  const selfAccountRepresentatives = useSelector(getSelfAccountRepresentativesSelector)

  const formattedOptions = useMemo(() => {
    return selfAccountRepresentatives.map(item => ({
      ...item,
      value: item.id,
      label: getRepresentativeTitle(item)
    }))
  }, [selfAccountRepresentatives])

  useEffect(() => {
    dispatch(
      // won’t need pagination there shouldn’t be more than 10 per account
      getSelfAccountRepresentatives({
        account: selfAccount
      })
    )
  }, [dispatch, selfAccount])

  useEffect(() => {
    return () => {
      dispatch(clearGetSelfAccountRepresentatives())
    }
  }, [dispatch])

  return (
    <Field
      formik={formik}
      name={CUSTOMER_REPRESENTATIVE}
      placeholder={t('Customer Representative')}
      options={formattedOptions}
      showClearInputIcon={!!values[CUSTOMER_REPRESENTATIVE]}
    />
  )
}

export default CustomerRepresentativeField
